export default "__VITE_ASSET__CO$nLge___"